import PendoIcon from '../../icon/pendo-icon.vue.js';
import PendoMultiselectValue from '../pendo-multiselect-value.vue.js';
import { setStyles } from '../../../utils/dom.js';

var script = {
  name: 'PendoGuideStatusTrigger',
  components: {
    PendoIcon,
    PendoMultiselectValue
  },
  inject: ['multiselect'],
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'outline',
      validator: type => ['fill', 'outline'].includes(type)
    },
    size: {
      type: String,
      default: 'mini',
      validator: size => ['medium', 'mini'].includes(size)
    }
  },
  computed: {
    status() {
      const key = this.multiselect.valueKey;
      return this.multiselect.selectedValue && this.multiselect.selectedValue[key];
    }
  },
  watch: {
    'multiselect.isOpen': function (isOpen) {
      if (isOpen) {
        this.$el.focus();
      }
    },
    'multiselect.minTriggerWidth': function () {
      const minWidth = 92;
      setStyles(this.$refs.trigger, {
        minWidth: this.multiselect.isFullWidth ? '100%' : minWidth
      });
    },
    'multiselect.maxTriggerWidth': function () {
      setStyles(this.$refs.trigger, {
        maxWidth: this.multiselect.maxTriggerWidth
      });
    }
  },
  mounted() {
    const minWidth = 92;
    setStyles(this.$refs.trigger, {
      minWidth: this.multiselect.isFullWidth ? '100%' : minWidth,
      maxWidth: this.multiselect.maxTriggerWidth
    });
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-status-trigger.vue2.js.map
